import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ButtonModule } from "primeng/button";
import { DialogBaseComponent, DialogParams } from "app/shared/dialog-base.component";
import { DomainService } from "app/shared/domain.service";

export interface ShippingAddressItem {
  shippingAddress1: string;
  joCount: number;
}

export interface SelectShippingAddressDialogParams extends DialogParams {
  addresses: ShippingAddressItem[];
}

@Component({
  selector: "app-select-shipping-address-dialog",
  template: `
    <div class="flex flex-col h-full p-4">
      <div class="flex-1 overflow-auto">
        <div *ngFor="let addr of addresses"
             class="p-3 border-b cursor-pointer hover:bg-primary-50 transition-colors"
             (click)="selectAddress(addr)">
          <div class="font-semibold">{{ addr.shippingAddress1 }}</div>
          <div class="text-xs text-gray-400 mt-1">
            {{ addr.joCount }} job order{{ addr.joCount !== 1 ? 's' : '' }}
          </div>
        </div>
      </div>

      <div class="flex justify-end pt-3 border-t mt-3">
        <button pButton type="button" class="p-button-raised p-button-outlined" (click)="onCancel()">
          <span>Cancel</span>
        </button>
      </div>
    </div>
  `,
  standalone: true,
  imports: [CommonModule, ButtonModule],
})
export class SelectShippingAddressDialogComponent extends DialogBaseComponent<SelectShippingAddressDialogParams> {
  addresses: ShippingAddressItem[] = [];

  constructor(
    public override config: DynamicDialogConfig<SelectShippingAddressDialogParams>,
    public override dialogRef: DynamicDialogRef,
    public override domainService: DomainService,
  ) {
    super(config, dialogRef, domainService);
    this.addresses = this.params.addresses;
    this.isPageReady = true;
  }

  selectAddress(addr: ShippingAddressItem) {
    this.dialogRef.close(addr);
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
